export enum NotificationEnum {
  ACCEPTED_TIME_TRACKING = 'ACCEPTED_TIME_TRACKING',
  ACTION_REQUIRED_ACCEPT_INVITEE = 'ACTION_REQUIRED_ACCEPT_INVITEE',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  ADD_TIME_TRACKING = 'ADD_TIME_TRACKING',
  APPROVE_TIME_TRACKING_FOR_AGENCY = 'APPROVE_TIME_TRACKING_FOR_AGENCY',
  APPROVE_TIME_TRACKING_FOR_HOSPITAL = 'APPROVE_TIME_TRACKING_FOR_HOSPITAL',
  APPROVE_TIME_TRACKING_FOR_CREATOR = 'APPROVE_TIME_TRACKING_FOR_CREATOR',
  APPROVE_TIME_TRACKING_REMINDER_FOR_AGENCY = 'APPROVE_TIME_TRACKING_REMINDER_FOR_AGENCY',
  APPROVE_TIME_TRACKING_REMINDER_FOR_HOSPITAL = 'APPROVE_TIME_TRACKING_REMINDER_FOR_HOSPITAL',
  APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR = 'APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR',
  BOOKED_INTERNAL = 'BOOKED_INTERNAL',
  BOOKED_EXTERNAL = 'BOOKED_EXTERNAL',
  DECLINED = 'DECLINED',
  ENROLL_POOLER_ACCOUNT = 'ENROLL_POOLER_ACCOUNT',
  ENROLL_DISPO_ACCOUNT = 'ENROLL_DISPO_ACCOUNT',
  ENROLL_DEMO_ACCOUNT = 'ENROLL_DEMO_ACCOUNT',
  ENROLLMENT_COMPLETED_POOLER = 'ENROLLMENT_COMPLETED_POOLER',
  ENROLLMENT_COMPLETED_DISPO = 'ENROLLMENT_COMPLETED_DISPO',
  ENROLL_PHONE = 'ENROLL_PHONE',
  AUTO_ENROLL_ACCOUNT = 'AUTO_ENROLL_ACCOUNT',
  EXTERNAL_API_REQUEST_FAILED = 'EXTERNAL_API_REQUEST_FAILED',
  INVITEE_CANCELED = 'INVITEE_CANCELED',
  INVITEE_REPLACED = 'INVITEE_REPLACED',
  INVITE = 'INVITE',
  JOB_CANCELED = 'JOB_CANCELED',
  JOB_DECLINED = 'JOB_DECLINED',
  JOB_CLOSED = 'JOB_CLOSED',
  JOB_MISSED = 'JOB_MISSED',
  JOB_REOPENED = 'JOB_REOPENED',
  JOB_REOPENED_INVITE = 'JOB_REOPENED_INVITE',
  JOB_REOPENED_TRANSFER = 'JOB_REOPENED_TRANSFER',
  JOB_REQUESTED = 'JOB_REQUESTED',
  JOB_REQUEST_ACCEPTED = 'JOB_REQUEST_ACCEPTED',
  JOB_REQUEST_DECLINED = 'JOB_REQUEST_DECLINED',
  JOB_RETRACTION_REQUESTED = 'JOB_RETRACTION_REQUESTED',
  JOB_RETRACTION_REQUEST_ACCEPTED = 'JOB_RETRACTION_REQUEST_ACCEPTED',
  JOB_RETRACTION_REQUEST_DECLINED = 'JOB_RETRACTION_REQUEST_DECLINED',
  NEW_ACCOUNT_PHONE_TOKEN = 'NEW_ACCOUNT_PHONE_TOKEN',
  EMAIL_OPT_IN = 'EMAIL_OPT_IN',
  PHONE_OPT_IN = 'PHONE_OPT_IN',
  ORGANISATION_REQUEST = 'ORGANISATION_REQUEST',
  POOL_ACCEPTED = 'POOL_ACCEPTED',
  POOL_DECLINED = 'POOL_DECLINED',
  POOLER_INVITE_REMINDER = 'POOLER_INVITE_REMINDER',
  POOLER_JOB_REMINDER = 'POOLER_JOB_REMINDER',
  POOLER_TRANSFERRED = 'POOLER_TRANSFERRED',
  POOL_REMOVED = 'POOL_REMOVED',
  POOL_REQUEST = 'POOL_REQUEST',
  POSSIBLE_CANDIDATE = 'POSSIBLE_CANDIDATE',
  PROFILE_INFO_CHANGED = 'PROFILE_INFO_CHANGED',
  REASK = 'REASK',
  TRANSFER_DECLINED = 'TRANSFER_DECLINED',
  TRANSFER_EXTERNAL_API_REQUEST_FAILED = 'TRANSFER_EXTERNAL_API_REQUEST_FAILED',
  TRANSFER = 'TRANSFER',
  TWO_FACTOR_AUTH_PHONE = 'TWO_FACTOR_AUTH_PHONE',
  TWO_FACTOR_AUTH_EMAIL = 'TWO_FACTOR_AUTH_EMAIL',
  EMPLOYMENT_BOOKED_INTERNAL = 'EMPLOYMENT_BOOKED_INTERNAL',
  EMPLOYMENT_BOOKED_EXTERNAL = 'EMPLOYMENT_BOOKED_EXTERNAL',
  EMPLOYMENT_INVITE = 'EMPLOYMENT_INVITE',
  EMPLOYMENT_INVITEE_CANCELED = 'EMPLOYMENT_INVITEE_CANCELED',
  EMPLOYMENT_INVITEE_DECLINED = 'EMPLOYMENT_INVITEE_DECLINED',
  EMPLOYMENT_ACTION_REQUIRED = 'EMPLOYMENT_ACTION_REQUIRED',
  EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE = 'EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE',
  EMPLOYMENT_TRANSFER = 'EMPLOYMENT_TRANSFER',
  EMPLOYMENT_TRANSFER_DECLINED = 'EMPLOYMENT_TRANSFER_DECLINED',
  AVAILABILITY_UPDATES_REPORT = 'AVAILABILITY_UPDATES_REPORT',
  EMPLOYMENT_INFORMATION_CHANGED = 'EMPLOYMENT_INFORMATION_CHANGED',
  EMPLOYMENT_POSSIBLE_CANDIDATE = 'EMPLOYMENT_POSSIBLE_CANDIDATE',
  EMPLOYMENT_CLOSED = 'EMPLOYMENT_CLOSED',
  EMPLOYMENT_CANCELED = 'EMPLOYMENT_CANCELED',
  AUTO_BOOKED_ON_TRANSFER = 'AUTO_BOOKED_ON_TRANSFER',
  AUTO_POSSIBLE_CANDIDATE_ON_TRANSFER = 'AUTO_POSSIBLE_CANDIDATE_ON_TRANSFER',
  NEW_JOB_REQUEST_NEEDS_APPROVAL = 'NEW_JOB_REQUEST_NEEDS_APPROVAL',
  DEMO_SETUP_REQUESTED = 'DEMO_SETUP_REQUESTED',
  DEMO_USER_REGISTERED = 'DEMO_USER_REGISTERED',
  DEMO_SETUP_CANCELED = 'DEMO_SETUP_CANCELED',
  DEMO_WELCOME = 'DEMO_WELCOME',
  UNMAPPED_PERIGON_JOBS = 'UNMAPPED_PERIGON_JOBS',
  DISPO_REMOVED_FROM_POOL = 'DISPO_REMOVED_FROM_POOL',
  REQUESTER_REMOVED_FROM_POOL = 'REQUESTER_REMOVED_FROM_POOL',
  POOLER_REMOVED_FROM_POOL = 'POOLER_REMOVED_FROM_POOL',
}

export enum UserLogEnum {
  INVITE = 'INVITE',
  BOOKED = 'BOOKED',
  DECLINED = 'DECLINED',
  AVAILABLE = 'AVAILABLE',
  PARTIAL_AVAILABLE = 'PARTIAL_AVAILABLE',
  PARTIAL_TIMES_EDIT = 'PARTIAL_TIMES_EDIT',
  UNAVAILABLE = 'UNAVAILABLE',
  SELF_SIGN_IN = 'SELF_SIGN_IN',
  POSSIBLE_CANDIDATE = 'POSSIBLE_CANDIDATE',
  INVITEE_REPLACED = 'INVITEE_REPLACED',
  INVITEE_CANCELED = 'INVITEE_CANCELED',
  JOB_CANCELED = 'JOB_CANCELED',
  TRANSFERRED = 'TRANSFERRED',
  JOB_REMINDER = 'JOB_REMINDER',
  INVITE_REMINDER = 'INVITE_REMINDER',
  WORKING = 'WORKING',
  RE_ASK = 'RE_ASK',
  JOB_REOPENED = 'JOB_REOPENED',
  JOB_REOPENED_INVITE = 'JOB_REOPENED_INVITE',
  JOB_REOPENED_TRANSFER = 'JOB_REOPENED_TRANSFER',
}

export enum NotificationTypeEnum {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  PUSH = 'PUSH',
}

export type NotificationChannels = {
  [key in NotificationTypeEnum]: boolean;
};

export type EmailAttachment = {
  filename: string;
  content: string;
  encoding?: string;
  cid?: string;
};
